import { useState } from 'react'
import './FineTuningComponentProfiles.css'

export const FineTuningComponentProfiles = ({
	profile,
	setSelectedProfile
}: {
	profile: string,
	setSelectedProfile: (profile: string) => void
}) => {

	const [activeButton, setActiveButton] = useState<string | undefined>(profile)
	const [activeButtonHover, setActiveButtonHover] = useState<string | undefined>(undefined)

	return (
		<div className='fine-tuning-component-profiles'>

			<div
				className={`fine-tuning-component-profiles-button ${activeButton === 'race' ? "active" : "inactive"} ${profile} ${activeButtonHover === 'race' ? "hover" : ""}`}
				onMouseEnter={() => { setActiveButtonHover('race') }}
				onMouseLeave={() => setActiveButtonHover(undefined)}
				onClick={() => { setSelectedProfile('race'); setActiveButton('race') }}
			>
				<img
					className={`fine-tuning-component-profiles-button-img ${activeButton === 'race' ? 'active' : ''} ${profile}`}
					src="./icons/24px/race_car_settings.svg"
					alt="race_car_settings"
				/>
				<p className='fine-tuning-component-profiles-text'>RACE</p>
				<div></div>
			</div>

			<div
				className={`fine-tuning-component-profiles-button ${activeButton === 'drift' ? "active" : "inactive"} ${profile} ${activeButtonHover === 'drift' ? "hover" : ""}`}
				onMouseEnter={() => { setActiveButtonHover('drift') }}
				onMouseLeave={() => setActiveButtonHover(undefined)}
				onClick={() => { setSelectedProfile('drift'); setActiveButton('drift') }}
			>
				<img
					className={`fine-tuning-component-profiles-button-img ${activeButton === 'drift' ? 'active' : ''} ${profile}`}
					src="./icons/24px/drift_car_settings.svg"
					alt="drift_car_settings"
				/>
				<p className='fine-tuning-component-profiles-text'>DRIFT</p>
				<div></div>
			</div>

		</div>
	)
}